import { Card, Row } from 'reactstrap';

import { Else, IconButton, If, Then } from '@hsp/react-component-library';

import { SearchBox } from '@c/layouts/shared';
import { ToolbarItems } from '@c/table';

import AddUserSlideOut from '@p/security/users/dashboard/component/slideout/add-user/slideout.component';
import UserFilterSlideOut from '@p/security/users/dashboard/component/slideout/filter/filter.component';
import UserCards from '@p/security/users/dashboard/component/user-cards/card.component';
import RoleTabs from '@p/security/users/dashboard/component/user-cards/role.component';
import { userStore } from '@p/security/users/store/store';

import { groupTabs } from '@t/p/security/users/tabs.enums';

const UserDashboard = () => {
  const { tab, setIsOpenFilter, setAddUser } = userStore();

  return (
    <>
      <Row>
        <ToolbarItems>
          <div className=" d-flex justify-content-between">
            <SearchBox />
            <div>
              {/* <IconButton
                className="me-3"
                color="outline-primary "
                icon={'people-group'}>
                Client Groups
              </IconButton> */}
              <IconButton
                className="me-3"
                color="outline-primary"
                icon={'add'}
                onClick={() => setAddUser(true)}>
                Add User
              </IconButton>
              <IconButton
                color="outline-primary"
                icon={'filter'}
                onClick={() => setIsOpenFilter(true)}>
                Filter
              </IconButton>
            </div>
          </div>
        </ToolbarItems>
      </Row>

      <Card>
        <If condition={tab === groupTabs.All}>
          <Then>
            <>
              <UserCards />
            </>
          </Then>
          <Else>
            <RoleTabs />

            <UserCards />
          </Else>
        </If>
      </Card>
      <UserFilterSlideOut />
      <AddUserSlideOut />
    </>
  );
};

export default UserDashboard;
